/** Matches \Tuupola\Base58::BITCOIN in the backend */
const BITCOIN = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

const base58 = (function (alpha) {
  const alphabet = alpha;
  const base = alphabet.length;
  return {
    encode: /** @param {number} enc */ function (enc) {
      let encoded = "";
      while (enc) {
        const remainder = enc % base;
        enc = Math.floor(enc / base);
        encoded = alphabet[remainder].toString() + encoded;
      }
      return encoded;
    },
    decode: /** @param {string} dec */ function (dec) {
      let decoded = 0;
      while (dec) {
        const alphabetPosition = alphabet.indexOf(dec[0]);
        if (alphabetPosition < 0) {
          throw new Error(
            `"decode" can't find "${dec[0]}" in the alphabet "${alphabet}"`,
          );
        }
        const powerOf = dec.length - 1;
        decoded += alphabetPosition * Math.pow(base, powerOf);
        dec = dec.substring(1);
      }
      return decoded;
    },
  };
})(BITCOIN);

export const { encode, decode } = base58;
